export default __webpack_public_path__ + "static/media/greek-q-mark.9406e64d.png";